import React from 'react';

class SocietyInfo extends React.Component {

  _setMaj = (string) => {
    try {
      if(string !== null){
        const newString = string.split("-")
        for (var i = 0; i < newString.length; i++) {
          newString[i] = newString[i].charAt(0).toUpperCase() + newString[i].slice(1);
        }
        const newStringJoin = newString.join("-")
        return (newStringJoin)
      }
      return ('')
    }catch (e){
      return (string)
    }
}

  render (){
    return (
      <div style={{display: 'flex', width: '100%'}}>
        <p style={{fontSize: '1em', fontWeight: 'bold', color: 'grey'}}>{this.props.SocietyInfo && this.props.SocietyInfo.Name ? this._setMaj(this.props.SocietyInfo.Name) : ""} - {this.props.SocietyInfo && this.props.SocietyInfo.Status ? this._setMaj(this.props.SocietyInfo.Status) : ""}</p>
      </div>
    )
  }
}

export default SocietyInfo;
